import { UserPermissions } from "Infrastructure/Api/permissions";
import { PermissionGuard } from "Infrastructure/Components/PermissionGuard";
import { PartnershipRecordsPage } from "Partner/Modules/PartnershipRecords/Pages/PartnershipRecordsPage";
import { PartnersPage } from "Partner/Pages";
import { PartnerCalendarPage } from "Partner/Pages/Calendar";
import { PartnerCreatePage } from "Partner/Pages/CreatePage";
import { PartnerDetailPage } from "Partner/Pages/Detail";
import { PartnerDetailTabs } from "Partner/Pages/Detail/Tabs/Hooks/usePartnerDetailTabs";
import { PartnerPaths } from "Partner/Routes/Routing";

export const PartnerRoutes = [
	{
		path: PartnerPaths.Index.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.PartnerModule.read}>
				<PartnersPage />
			</PermissionGuard>
		),
	},
	{
		path: PartnerPaths.Edit.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.PartnerModule.view}>
				<PartnerDetailPage currentTab={PartnerDetailTabs.edit} />
			</PermissionGuard>
		),
	},
	{
		path: PartnerPaths.Detail.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.PartnerModule.view}>
				<PartnerDetailPage currentTab={PartnerDetailTabs.detail} />
			</PermissionGuard>
		),
	},
	{
		path: PartnerPaths.Orders.route,
		exact: true,
		element: (
			<PermissionGuard
				permission={[
					UserPermissions.PartnerModule.view,
					UserPermissions.OrderModule.read,
				]}
			>
				<PartnerDetailPage currentTab={PartnerDetailTabs.orders} />
			</PermissionGuard>
		),
	},
	{
		path: PartnerPaths.Balance.route,
		exact: true,
		element: (
			<PermissionGuard
				permission={[
					UserPermissions.PartnerModule.view,
					UserPermissions.PartnerBalanceModule.read,
				]}
			>
				<PartnerDetailPage currentTab={PartnerDetailTabs.balance} />
			</PermissionGuard>
		),
	},
	{
		path: PartnerPaths.Invoice.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.PartnerModule.view}>
				<PartnerDetailPage currentTab={PartnerDetailTabs.invoice} />
			</PermissionGuard>
		),
	},
	{
		path: PartnerPaths.Availability.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.PartnerModule.read}>
				<PartnerDetailPage currentTab={PartnerDetailTabs.availability} />
			</PermissionGuard>
		),
	},
	{
		path: PartnerPaths.Create.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.PartnerModule.create}>
				<PartnerCreatePage />
			</PermissionGuard>
		),
	},
	{
		path: PartnerPaths.Calendar.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.PartnerModule.read}>
				<PartnerCalendarPage />
			</PermissionGuard>
		),
	},
	{
		path: PartnerPaths.PartnershipRecords.route,
		exact: true,
		element: (
			<PermissionGuard permission={UserPermissions.PartnerModule.read}>
				<PartnershipRecordsPage />
			</PermissionGuard>
		),
	},
];
